module.exports = __webpack_public_path__ + "static/img/1.7c04e58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.jpg
// module id = tGse
// module chunks = 0